/*
 * @Desc: 
 * @Author: lc
 * @Date: 2024-08-24 14:12:18
 * @LastEditors: lc
 * @LastEditTime: 2024-12-11 14:27:14
 */
import Vue from 'vue'
import Router from 'vue-router'
import store from '.././vuex/store'
import iView from 'view-design'
import routers from './routers'

Vue.use(Router)

const router = new Router({
  //   mode: 'history',
  routes: routers
})
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch((err) => err)
}
// 导航钩子，全局钩子
router.beforeEach((to, from, next) => {
  // 登录页面
  if (to.name === 'login') {
    if (store.getters.token === '') {
      next()
    } else {
      next('/index/index')
    }
  } else {
    // console.log("to.meta.requiresAuth",to.meta.requiresAuth);
    // 其它页面
    if (store.getters.token === '' && to.meta.requiresAuth) {
      next('/login')
    } else {
      next()
    }
  }
})
router.afterEach((to) => {
  iView.LoadingBar.finish()
})

export default router
